import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import ExamRoomModal from "./partials/ExamRoomModal";
import AssignmentModal from "./partials/AssignmentModal";

import {
    getExamRooms    as onGetExamRooms,
    deleteExamRoom  as onDeleteExamRoom,
} from "store/actions";

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Col, Row, Card, CardBody, Button, Badge } from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";

import { useNavigate } from 'react-router-dom'; // Ajoutez cet import

const ExamRoom = () => {
    document.title = "Salles d'examen | CinzanEdu";

    const dispatch = useDispatch();

    const navigate = useNavigate(); // Ajoutez cette ligne


    const [modal,            setModal]            = useState(false);
    const [isEdit,           setIsEdit]           = useState(false);
    const [examRoom,         setExamRoom]         = useState(null);
    const [deleteModal,      setDeleteModal]      = useState(false);
    const [assignmentModal,  setAssignmentModal]  = useState(false);
    const [selectedRoom,     setSelectedRoom]     = useState(null);

    const ExamRoomProperties = createSelector(
        (state) => state.examRoomReducer,
        (r) => ({
            examRooms: r.examRooms || [],
            loading:   r.loading,
        })
    );

    const { examRooms, loading } = useSelector(ExamRoomProperties);
    const [isLoading, setLoading] = useState(true);

    console.log("EXAM ROOMS: ", examRooms);

    useEffect(() => {
        dispatch(onGetExamRooms());
    }, [dispatch]);

    const toggle = () => {
        setModal(!modal);
        if (modal) setExamRoom(null);
    };

    const handleNewRoom = () => {
        setIsEdit(false);
        setExamRoom(null);
        toggle();
    };

    const handleEditRoom = (room) => {
        setExamRoom(room);
        setIsEdit(true);
        toggle();
    };

    const handleDeleteRoom = (room) => {
        setExamRoom(room);
        setDeleteModal(true);
    };

    const handleProgrammer = (room) => {
        setSelectedRoom(room);
        setAssignmentModal(true);
    };

    const handleViewAssignments = () => {
        navigate('/exam-room-assignments'); // ou le chemin de votre route
    };

    const columns = useMemo(() => [
        {
            header: "Code",
            accessorKey: "code",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) => (
                <span className="fw-bold text-primary">
                    {cellProps.row.original.code}
                </span>
            ),
        },
        {
            header: "Nom",
            accessorKey: "name",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Capacité",
            accessorKey: "capacity",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cellProps) => (
                <Badge color="info">
                    {cellProps.row.original.capacity} places
                </Badge>
            ),
        },
        {
            header: "Statut",
            accessorKey: "is_active",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cellProps) => (
                <Badge color={cellProps.row.original.is_active ? "success" : "danger"}>
                    {cellProps.row.original.is_active ? "Active" : "Inactive"}
                </Badge>
            ),
        },
        {
            header: "Actions",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cellProps) => (
                <ul className="list-unstyled hstack gap-1 mb-0">
                    
                    <li>
                        <Button
                            color="info"
                            size="sm"
                            onClick={() => handleEditRoom(cellProps.row.original)}
                        >
                            <i className="bx bx-edit"></i>
                        </Button>
                    </li>
                    <li>
                        <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDeleteRoom(cellProps.row.original)}
                        >
                            <i className="bx bx-trash"></i>
                        </Button>
                    </li>
                    <li>
                        <Button
                            color="warning"
                            size="sm"
                            onClick={() => handleProgrammer(cellProps.row.original)}
                        >
                            <i className="bx bx-calendar"></i> Programmer
                        </Button>
                    </li>
                </ul>
            ),
        },
    ], []);

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={() => {
                    dispatch(onDeleteExamRoom(examRoom));
                    setDeleteModal(false);
                }}
                onCloseClick={() => setDeleteModal(false)}
            />

            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Examens" breadcrumbItem="Salles d'examen" />

                    {loading ? <Spinners setLoading={setLoading} /> :
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="border-bottom d-flex justify-content-between align-items-center">
                                        <div className="text-muted small">
                                            {examRooms.length} salle(s)
                                        </div>
                                        {/* SECTION MODIFIÉE */}
                                        <div className="d-flex gap-2">
                                            <Button 
                                                color="success" 
                                                outline
                                                onClick={handleViewAssignments}
                                            >
                                                <i className="bx bx-calendar-check me-1"></i>
                                                Voir les planifications
                                            </Button>
                                            
                                            <Button color="primary" onClick={handleNewRoom}>
                                                <i className="bx bx-plus me-1"></i>
                                                Nouvelle salle
                                            </Button>
                                        </div>
                                    </CardBody>
                                    <CardBody>
                                        <TableContainer
                                            columns={columns}
                                            data={examRooms}
                                            isCustomPageSize={true}
                                            isGlobalFilter={true}
                                            isPagination={true}
                                            SearchPlaceholder="Rechercher une salle..."
                                            tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                            theadClass="table-light"
                                            pagination="pagination"
                                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    }
                </div>
            </div>

            <ExamRoomModal
                isOpen={modal}
                toggle={toggle}
                isEdit={isEdit}
                examRoom={examRoom}
            />

            <AssignmentModal
                isOpen={assignmentModal}
                toggle={() => setAssignmentModal(false)}
                examRoom={selectedRoom}
            />

            <ToastContainer />
        </React.Fragment>
    );
};

export default ExamRoom;